import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export const AssignLead = ({ p, onAssigned }) => {
  const [mlos, setMlos] = useState([]);
  useEffect(() => { api.get("/admin/users").then((r) => setMlos(r.data.filter((u) => u.account_status === "active"))).catch(() => {}); }, []);
  const assign = async (mlo_id) => {
    try { await api.post(`/admin/prospects/${p.id}/assign`, { mlo_id }); toast.success("Lead reassigned"); onAssigned?.(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="mt-3" data-testid="assign-lead">
      <div className="mb-1 text-[10px] font-semibold uppercase tracking-wider text-slate-400">Assigned loan officer</div>
      <Select value={p.mlo_id} onValueChange={assign}>
        <SelectTrigger className="h-9" data-testid="assign-lead-select"><SelectValue placeholder="Choose loan officer" /></SelectTrigger>
        <SelectContent>
          {mlos.map((u) => <SelectItem key={u.id} value={u.id} data-testid={`assign-option-${u.id}`}>{`${u.first_name || ""} ${u.last_name || ""}`.trim() || u.email}{u.role === "admin" ? " (admin)" : ""}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};
